var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"}),_c('p',{staticStyle:{"display":"none"},attrs:{"id":"capcha_dom_id"}}),(_vm.showIntercept)?[_c('Intercept')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }